import Slider from "react-slick";
export default function SliderBannerFour({ slideritems, layoutColor }) {

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <g id="Group_183" data-name="Group 183" transform="translate(-1793 -2944)">
                    <g id="Ellipse_36" data-name="Ellipse 36" transform="translate(1833 2944) rotate(90)" fill="none" stroke="#000" stroke-width="2">
                    <circle cx="20" cy="20" r="20" stroke="none"/>
                    <circle cx="20" cy="20" r="19" fill="none"/>
                    </g>
                    <g id="Group_94" data-name="Group 94" transform="translate(133.5 265.749)">
                    <path id="Path_101" data-name="Path 101" d="M0,0,5.87,7.466,12,0" transform="translate(1680.034 2704.751) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <line id="Line_12" data-name="Line 12" y2="15.034" transform="translate(1686.534 2698.751) rotate(90)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="2"/>
                    </g>
                </g>
                </svg>

            </div>
        );
    }
    
    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                onClick={onClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                    <g id="Group_183" data-name="Group 183" transform="translate(-1793 -2944)">
                        <g id="Ellipse_36" data-name="Ellipse 36" transform="translate(1833 2944) rotate(90)" fill="none" stroke="#000" stroke-width="2">
                        <circle cx="20" cy="20" r="20" stroke="none"/>
                        <circle cx="20" cy="20" r="19" fill="none"/>
                        </g>
                        <g id="Group_94" data-name="Group 94" transform="translate(133.5 265.749)">
                        <path id="Path_101" data-name="Path 101" d="M0,0,5.87,7.466,12,0" transform="translate(1680.034 2704.751) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <line id="Line_12" data-name="Line 12" y2="15.034" transform="translate(1686.534 2698.751) rotate(90)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="2"/>
                        </g>
                    </g>
                </svg>

            </div>
        );
    }


    const settings = {
        dots: false,
        infinite: false,
        draggable: false,
        arrows: true,
        speed: 500,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              }
            }
        ]
    };  
	return (
		<>
            {slideritems && 
                <Slider  {...settings}>
                    {
                        slideritems.map(
                            ({megaText, title, subtitle, buttonText, buttonUrl, imagesUrl}, index) => {
                                return(
                                    <div class="servicex-banner-area-me">
                                        <div
                                            class="
                                                servicex-sub-service-item
                                                splide__slide
                                            "
                                            style={{backgroundImage: `url(${imagesUrl})`}}
                                        >
                                            <div
                                                class="
                                                    servicex-sub-service-item-title
                                                "
                                            >
                                                {console.log(layoutColor)}
                                                {megaText &&
                                                    <h4 dangerouslySetInnerHTML={{__html: megaText}} />
                                                }
                                                <h5>
                                                    <a class="read-more" href={buttonUrl}  style={{color: layoutColor }}  >{title}</a>
                                                </h5>
                                                <p dangerouslySetInnerHTML={{__html: subtitle}} />
                                                {buttonText &&
                                                    <a class="read-more" href={buttonUrl}>{buttonText}</a>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                )
                            }
                        )
                    }
                </Slider>
            }
		</>
	);
}


